import { fetchData } from "@app/Helpers";
import { getAppData } from "../../storageFallback";

export function initSession(successCallback) {
    const payload = {}

    const controller = new AbortController();

    return fetchData({
        endpoint: "/web/session",
        payload,
        successCallback,
        shouldThrowError: false,
        controller: controller,
    });
}

export function sendSessionEv(event, value) {
    const payload = {
        event: {
            sessionId: getAppData("sId"),
            ident: event,
            value: value
        }
    }

    const controller = new AbortController();

    return fetchData({
        endpoint: "/web/event",
        payload,
        shouldThrowError: false,
        controller: controller,
    });
}